import type { ReactNode } from 'react';

interface Moment {
  time: string;
  label: string;
  detail?: string;
}

// The order of the day — Saturday, 3 October 2026.
const MOMENTS: Moment[] = [
  { time: '4:00 – 5:00 pm', label: 'Guests Arrive', detail: 'Welcome drinks & mingling' },
  { time: '5:00 pm', label: 'Ceremony', detail: 'The vows' },
  { time: '7:00 pm', label: 'Dinner', detail: 'Feasting & toasts' },
  { time: '9:00 pm', label: 'Fireworks', detail: 'Under the night sky' },
  { time: '10:00 pm', label: 'Event Concludes' },
];

function Rail({ last }: { last: boolean }): ReactNode {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'stretch',
      }}
    >
      <span
        style={{
          width: 11,
          height: 11,
          borderRadius: '50%',
          background: 'var(--gold)',
          boxShadow: '0 0 0 4px rgba(196,164,98,0.14)',
          marginTop: 5,
          flexShrink: 0,
        }}
      />
      {!last && <span style={{ width: 1, flex: 1, background: 'var(--border)', marginTop: 4 }} />}
    </div>
  );
}

/** Day-of timeline for the Overview page. */
export function Schedule() {
  return (
    <section style={{ marginTop: 30 }}>
      <p className="eyebrow" style={{ textAlign: 'center' }}>
        Order of the Day
      </p>
      <div
        style={{
          marginTop: 16,
          padding: '24px 22px 8px',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius)',
          background: 'var(--surface)',
        }}
      >
        {MOMENTS.map((m, i) => (
          <div
            key={m.label}
            style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 16 }}
          >
            <Rail last={i === MOMENTS.length - 1} />
            <div style={{ paddingBottom: i === MOMENTS.length - 1 ? 16 : 24 }}>
              <p className="eyebrow" style={{ color: 'var(--gold)', letterSpacing: '0.18em' }}>
                {m.time}
              </p>
              <p
                className="serif"
                style={{ fontSize: '1.5rem', margin: '2px 0 0', lineHeight: 1.1 }}
              >
                {m.label}
              </p>
              {m.detail && (
                <p style={{ color: 'var(--text-dim)', fontSize: 13, margin: '4px 0 0' }}>
                  {m.detail}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
